import { config } from "../../Config"

const changePublicationType = async (extensionId, userId, publicationType) => {
    const url = config.changeExtensionType;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                extensionId,
                userId,
                publicationType,
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            return { success: false, error: errorData.error || 'Failed to change publication type.' };
        }

        const data = await response.json();
        return { success: true, message: data.message };
    } catch (error) {
        // console.error("Error in changePublicationType:", error);
        return { success: false, error: 'An unexpected error occurred.' };
    }
};

export default changePublicationType;
